import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Autumn/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [1, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year2/Autumn/PlaceValue/1NumbersTo20" */ './1NumbersTo20')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/2CountObjectsTo100ByMaking10s" */ './2CountObjectsTo100ByMaking10s'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/3RecogniseTensAndOnes" */ './3RecogniseTensAndOnes'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/4UseAPlaceValueChart" */ './4UseAPlaceValueChart'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/5PartitionNumbersTo100" */ './5PartitionNumbersTo100'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/6WriteNumbersTo100InWords" */ './6WriteNumbersTo100InWords'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/7FlexiblyPartitionNumbersTo100" */ './7FlexiblyPartitionNumbersTo100'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/8WriteNumbersTo100InExpandedForm" */ './8WriteNumbersTo100InExpandedForm'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/9TensOnTheNumberLineTo100" */ './9TensOnTheNumberLineTo100'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/10TensAndOnesOnTheNumberLineTo100" */ './10TensAndOnesOnTheNumberLineTo100'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/11EstimateNumbersOnANumberLine" */ './11EstimateNumbersOnANumberLine'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/12CompareObjects" */ './12CompareObjects'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/13CompareNumbers" */ './13CompareNumbers'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/14OrderObjectsAndNumbers" */ './14OrderObjectsAndNumbers'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/PlaceValue/15CountIn2s5sAnd10s" */ './15CountIn2s5sAnd10s'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(/* webpackChunkName: "Year2/Autumn/PlaceValue/16CountIn3s" */ './16CountIn3s')
    })
  ]
});
export default Block;
